import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import useStyles from './styles';

function formatDateTime(isoString) {
  if (!isoString) return '-';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString('es-CL', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

function formatDurationMinutes(minutes) {
  const value = minutes != null && minutes !== '' ? Number(minutes) : null;
  if (value === null || Number.isNaN(value) || value < 0) return '-';
  if (value >= 60) {
    const h = Math.floor(value / 60);
    const m = value % 60;
    return m > 0 ? `${h} h ${m} min` : `${h} h`;
  }
  return `${value} min`;
}

function Results({
  className,
  supermarkets,
  loading,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.rootResults, className)}
      {...rest}
    >
      <PerfectScrollbar>
        <Box minWidth={700}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">
                  Nombre
                </TableCell>
                <TableCell align="center">
                  Fecha último scraping
                </TableCell>
                <TableCell align="center">
                  Duración último scraping
                </TableCell>
                <TableCell align="center">
                  Estado scraping
                </TableCell>
                <TableCell align="center">
                  Activo
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Cargando...
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {supermarkets && supermarkets.length > 0 ? (
                    supermarkets.map((row) => (
                      <TableRow hover key={row.id}>
                        <TableCell align="left">{row.name}</TableCell>
                        <TableCell align="center">
                          {formatDateTime(row.lastScrapingDate)}
                        </TableCell>
                        <TableCell align="center">
                          {formatDurationMinutes(row.scraping_duration_minutes ?? row.scrapingDurationMinutes)}
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            size="small"
                            label={row.scrapingStatus || 'Sin datos'}
                            color={row.scrapingStatus === 'En ejecución' ? 'primary' : 'default'}
                            variant={row.scrapingStatus === 'En ejecución' ? 'default' : 'outlined'}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            size="small"
                            label={row.scrape ? 'Sí' : 'No'}
                            color={row.scrape ? 'primary' : 'default'}
                            variant={row.scrape ? 'default' : 'outlined'}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No se encontraron supermercados
                      </TableCell>
                    </TableRow>
                  )}
                </>)}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
    </Card>
  );
}

Results.propTypes = {
  className: PropTypes.string,
  supermarkets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    scrape: PropTypes.bool,
    lastScrapingDate: PropTypes.string,
    scrapingStatus: PropTypes.string,
    scraping_duration_minutes: PropTypes.number,
  })),
};

Results.defaultProps = {
  supermarkets: [],
};

export default Results;
